import DataHandler from 'config/DataHandler';

export default (fileName, appId = DataHandler.matchAppIdSync()) =>
  `https://${[appContentUrl.replace(/^https?:\/\//g, ''), appId, fileName].join('/').replace(/\/\//g, '/')}`;
